import { ReactNode } from "react";
import { Box } from "@mui/material";

type Props = {
  in: boolean;
  children: ReactNode;
};

/**
 * Substitui o `Collapse` do MUI nas seções do chat (Informações, Follow-up
 * individual, Anotações do Alfred). Puro CSS (`max-height` + `overflow`),
 * sem Modal/Transition/portal — evita o bug de duplicação visual que o
 * `Collapse` causava aqui.
 */
export default function AnimatedCollapse({ in: open, children }: Props) {
  return (
    <Box
      sx={{
        overflow: "hidden",
        maxHeight: open ? 10000 : 0,
        opacity: open ? 1 : 0,
        transition: (theme) =>
          theme.transitions.create(["max-height", "opacity"], {
            duration: theme.transitions.duration.standard,
          }),
      }}
    >
      {children}
    </Box>
  );
}
